module.exports = __webpack_public_path__ + "static/media/coming-banner-mobile.135d8146.jpg";